import { usePagination } from '@fourthwall/components'
import { useOffersListingQuery } from '@hooks/useOffersListingQuery'

import { useSearchQuery } from '../../../hooks/useSearchQuery'
import { PER_PAGE } from '../../const'
import type { Product } from '../../types'
import { useFilterProducts } from '../useFilterProducts'

export const useProducts = () => {
  const [currentPage] = usePagination()
  const { filtersParams } = useFilterProducts()
  const { searchQuery } = useSearchQuery()
  const { offersListingQuery } = useOffersListingQuery(
    [
      {
        q: searchQuery,
        page: currentPage - 1,
        size: PER_PAGE,
        status: filtersParams.status
          ? (filtersParams.status.split(',') as ('PUBLIC' | 'HIDDEN' | 'ARCHIVED')[])
          : ['PUBLIC', 'HIDDEN'],
        stock: filtersParams.stock
          ? (filtersParams.stock.split(',') as ('AVAILABLE' | 'SOLD_OUT')[])
          : [],
      },
    ],
    {
      keepPreviousData: true,
    },
  )

  const mappedProducts: Product[] = offersListingQuery.data
    ? offersListingQuery.data.offers.map((offer) => ({
        ...offer,
        stock: {
          type: offer.stock.type,
          quantity: offer.stock.quantity || null,
          variants: offer.stock.variants.map((variant) => ({
            variant: variant.variant,
            stock: {
              type: variant.stock.type,
              quantity: variant.stock.quantity || null,
            },
          })),
        },
      }))
    : []

  return {
    products: mappedProducts,
    page: offersListingQuery.data?.page,
    isLoading: offersListingQuery.isFetching,
    refetchProducts: offersListingQuery.refetch,
  }
}
